import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../atom/ModalAtom';
import Header2 from '../component/Header2';
import { searchPasswordRecoil } from '../atom/UserAtom';
import { authAPI } from '../api/axiosIndex';

const PasswordSearchResult = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const [searchPassword, setSearchPassword] =
    useRecoilState(searchPasswordRecoil);

  const handlePasswordChange = async () => {
    if (password === '' || passwordConfirm === '') {
      setError(blankMsg);
      return;
    }

    if (password.length < 8 || !password.match(/^(?=.*[a-zA-Z])(?=.*\d).*$/)) {
      setError('영문과 숫자를 조합하여 8~20자로 입력해 주세요.');
      return;
    }

    if (password !== passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      await authAPI.putPasswordChange(searchPassword, password);
      navigate('/login');
      setConfirm('새로운 비밀번호로 변경이 완료되었습니다.');
    } catch (error) {
      setError('비밀번호 변경에 실패했습니다.\n다시 시도해 주세요.');
    }
  };

  return (
    <>
      <Header2 title={'비밀번호 찾기'} />
      <LS.LoginCntLayout>
        <CS.LoginInputWrap>
          <CS.LoginInputType>
            <h1>새로운 비밀번호</h1>
            <div>
              <input
                type="password"
                placeholder="비밀번호 입력 (영문 숫자 조합 8~20자)"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </CS.LoginInputType>
          <CS.LoginInputType>
            <h1>새로운 비밀번호 확인</h1>
            <div>
              <input
                type="password"
                placeholder="비밀번호 입력 확인"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
              />
            </div>
          </CS.LoginInputType>
        </CS.LoginInputWrap>
      </LS.LoginCntLayout>
      <LS.LoginBtnLayout>
        <CS.Btn1Type1 type="button" onClick={handlePasswordChange}>
          비밀번호 변경
        </CS.Btn1Type1>
      </LS.LoginBtnLayout>
    </>
  );
};

export default PasswordSearchResult;
